// extracted by mini-css-extract-plugin
export var dropdownButton = "_13-0";
export var fullWidthDropdownButton = "_13-1";
export var icon = "_13-3";
export var iconPlaceholder = "_13-2";
export var menuItemRow = "_13-9";
export var separator = "_13-e";
export var shortcutContainer = "_13-7";
export var shortcutContainerFilled = "_13-8";
export var shortcutIconLg = "_13-6";
export var shortcutIconMd = "_13-5";
export var shortcutIconSm = "_13-4";
export var submenuChevron = "_13-d";
export var submenuDropdown = "_13-a";
export var submenuTriggerRow = "_13-b";
export var submenuTriggerRowOpen = "_13-c";